/* @flow */

import classNames from 'classnames';
import { compose } from 'ramda';
import * as React from 'react';
import { createUseStyles } from 'react-jss';

import styles from './UserOnlineBadge.style';

import useEventAccentColor from 'src/shared/domain/event/hook/useEventAccentColor';

type Props = {
  layoutClass?: string,
  variant?: typeof large,
  onDarkBackground?: boolean,
};

const useStyles = createUseStyles(styles);

const UserOnlineBadge = ({
  layoutClass,
  variant,
  onDarkBackground,
}: Props): React.Node => {
  /*
   |----------------------------------------------------------------------------
   | Hooks
   |----------------------------------------------------------------------------
   */

  const [accentColor] = useEventAccentColor();

  /*
   |----------------------------------------------------------------------------
   | Classes
   |----------------------------------------------------------------------------
   */

  const classes: Object = useStyles({ accentColor });

  const rootClasses = classNames(classes.root, layoutClass, {
    [classes['root-large']]: variant === large,
    [classes['root-darkBg']]: onDarkBackground,
  });

  /*
   |----------------------------------------------------------------------------
   | Elements
   |----------------------------------------------------------------------------
   */

  return <div className={rootClasses} />;
};

export const large = Symbol();

export default compose(React.memo)(UserOnlineBadge);
